import React from 'react';

const IconeDroite = () => {
    return (
        <svg
            className="akar-icons-chevron-right"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
            d="M9.52783 5.05664L18.5278 14.0566L9.52783 23.0566"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            />
      </svg>
    );
}

export default IconeDroite